import { registerBrick, BrickContext } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import React from 'react';
import { Paper, IconButton, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default class MassChangeAdvancedSearchBar extends ReactBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @returns {Element}
     */

    static getReactComponent($) {
        return (props) => {
            const values1Label = useProperty($, 'Values 1 Label');
            const values2Label = useProperty($, 'Values 2 Label');
            const values1 = useProperty($, 'Values 1');
            const values2 = useProperty($, 'Values 2');

            // make a summary string of the selected data
            //  if no data selected, display 'advanced search'
            const values1Count =
                typeof values1 === 'string' ? values1.split(',').filter((s) => s.length > 0).length : 0;
            const values2Count =
                typeof values2 === 'string' ? values2.split(',').filter((s) => s.length > 0).length : 0;
            let summary = '';
            if (values1Count > 0) {
                summary = `${values1Count} ${values1Label}`;
            }
            if (values2Count > 0) {
                if (summary.length > 0) {
                    summary += ' and ';
                }
                summary += `${values2Count} ${values2Label}`;
            }
            if (summary.length > 0) {
                summary += ' selected';
            } else {
                summary = 'Advanced search';
            }

            return (
                <Paper
                    component="form"
                    sx={{
                        p: '2px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        width: '100%',
                        backgroundColor: 'rgb(250,250,250)',
                        cursor: 'pointer !important',
                    }}
                >
                    <IconButton
                        className={'base-popup-button'}
                        aria-label="search"
                        onClick={() => {
                            $.trigger('Trigger Advanced Search Popup');
                        }}
                    >
                        <Typography>{summary}</Typography>
                        <SearchIcon />
                    </IconButton>
                </Paper>
            );
        };
    }
}

registerBrick('0181ed228e61cad141f7', MassChangeAdvancedSearchBar);
